module.exports = __webpack_public_path__ + "static/media/Group 1152.223db1ca.png";